// extracted by mini-css-extract-plugin
module.exports = {"seeLiveProject5":"Stools-module--seeLiveProject5--1hSc0","sourceCodeProject5":"Stools-module--sourceCodeProject5--1kMZw"};